import { Plugin, PluginKey } from 'prosemirror-state';
import { EditorView } from 'prosemirror-view';
import { ySyncPluginKey } from 'y-prosemirror';
import { TASK_TOGGLE_META } from './task-plugin';

export const lockedModePluginKey = new PluginKey<boolean>('lockedMode');

export function lockedModePlugin(initialLocked = false): Plugin<boolean> {
  return new Plugin<boolean>({
    key: lockedModePluginKey,
    state: {
      init() {
        return initialLocked;
      },
      apply(tr, value) {
        const meta = tr.getMeta(lockedModePluginKey);
        if (typeof meta === 'boolean') {
          return meta;
        }
        return value;
      },
    },
    filterTransaction(tr, state) {
      const locked = lockedModePluginKey.getState(state);
      if (!locked) {
        return true;
      }

      // Allow meta-only transactions (like toggling locked mode itself)
      if (!tr.docChanged) {
        return true;
      }

      // Allow remote sync transactions from y-prosemirror
      if (tr.getMeta(ySyncPluginKey)) {
        return true;
      }

      // Only allow task toggle transactions
      return tr.getMeta(TASK_TOGGLE_META) === true;
    },
    props: {
      editable(state) {
        const locked = lockedModePluginKey.getState(state);
        return !locked;
      },
    },
  });
}

export function isLockedMode(view: EditorView): boolean {
  return lockedModePluginKey.getState(view.state) ?? false;
}

export function toggleLockedMode(view: EditorView): void {
  const currentState = isLockedMode(view);
  const tr = view.state.tr.setMeta(lockedModePluginKey, !currentState);
  view.dispatch(tr);
}
